/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-15 23:32:41
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-05-16 14:07:25
 * @FilePath: /zeelool-nextjs/src/app/account/my-wallet/components/AboutMyWallet.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// src/components/account/my-wallet/AboutMyWallet.tsx
import Dialog from '@/components/Dialog';
import Popup from '@/components/Popup';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useTranslations } from 'next-intl';
import React from 'react';

interface AboutMyWalletProps {
  open: boolean;
  onClose: () => void;
}

const AboutMyWallet: React.FC<AboutMyWalletProps> = ({ open, onClose }) => {
  const t = useTranslations('account.myWallet');

  return (
    <>
      <WebOnly>
        <Dialog
          open={open}
          onClose={onClose}
          title={t('aboutWallet.title')}
          fullWidth
          showTitleDivider
          showCloseIcon
          footer={null}
          sx={{
            '& .MuiDialog-paper': {
              maxWidth: '100%',
              width: '800px',
              height: '500px',
            },
          }}
        >
          <div className="">
            <p className="pt-20 pb-16 text-16 font-bs ">{t('aboutWallet.section1.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section1.content')}</p>

            <p className="pt-20 pb-16 text-16 font-bs ">{t('aboutWallet.section2.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section2.content')}</p>

            <p className="pt-20 pb-16 text-16   font-bs">{t('aboutWallet.section3.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section3.content')}</p>

            <p className="pt-20 pb-16 text-16  font-bs">{t('aboutWallet.section4.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section4.content')}</p>

            <p className="pt-20 pb-16 text-16 font-bs ">{t('aboutWallet.section5.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section5.content')}</p>

            <p className="pt-20 pb-16 text-16 font-bs ">{t('aboutWallet.section6.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section6.content')}</p>

            <p className="text-14 leading-[22px] mt-15">{t('aboutWallet.footer')}</p>
          </div>
        </Dialog>
      </WebOnly>
      <WapOnly>
        <Popup
          open={open}
          onClose={onClose}
          title={t('aboutWallet.title')}
          height="70vh"
          position="bottom"
        >
          <div className="">
            <p className="pt-20 pb-16 text-16 font-bs ">{t('aboutWallet.section1.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section1.content')}</p>

            <p className="pt-20 pb-16 text-16 font-bs ">{t('aboutWallet.section2.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section2.content')}</p>

            <p className="pt-20 pb-16 text-16   font-bs">{t('aboutWallet.section3.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section3.content')}</p>

            <p className="pt-20 pb-16 text-16  font-bs">{t('aboutWallet.section4.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section4.content')}</p>

            <p className="pt-20 pb-16 text-16 font-bs ">{t('aboutWallet.section5.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section5.content')}</p>

            <p className="pt-20 pb-16 text-16 font-bs ">{t('aboutWallet.section6.title')}</p>
            <p className="text-14 leading-[22px]">{t('aboutWallet.section6.content')}</p>

            <p className="text-14 leading-[22px] mt-[20px]">{t('aboutWallet.footer')}</p>
          </div>
        </Popup>
      </WapOnly>
    </>
  );
};

export default AboutMyWallet;
